import React from 'react';

import { ActionableLink, AgentInfo } from 'root/widgets';

import { extractDataAutomationId, filterMetadata } from 'root/widgets/utils';

import './contact-agent-card.scss';
import { ContactAgentCardProps } from './types';

const ContactAgentCard: React.FC<ContactAgentCardProps> = ({
  agentInfoProps: agentInfo,
  contactActions,
  liveTour,
  agency,
  termsAndPolicy,
  metadata,
}) => (
  <div className="contact-agent-card-root" {...filterMetadata(metadata)} {...extractDataAutomationId(metadata)}>
    <div className="card-header">
      {agency && (
        <div className="agency">
          <img className="agency-avatar" src={agency.avatar} alt={agency.name} />
          {agency.name}
        </div>
      )}
      <AgentInfo {...agentInfo} />
    </div>
    <div className="card-body">
      {contactActions.map((action, index) => (
        <ActionableLink key={`contact-agent-${index}`} className="btn-outline-secondary btn" {...action} />
      ))}
      {termsAndPolicy && <div className="terms-and-policy">{termsAndPolicy}</div>}
    </div>
    {liveTour && (
      <div className="card-footer">
        <div className="live-tour">
          <div className="live-tour-badge">
            <i className="pgicon-video-call" />
            {liveTour.text}
          </div>
          {liveTour.description}
        </div>
      </div>
    )}
  </div>
);

ContactAgentCard.displayName = 'ContactAgentCard';

export default ContactAgentCard;
